const BrandingSettings = {
    organisationLogo: {
        acceptedTypes: "image/jpeg, image/png",
        displayHeight: 75,
        displayWidth: 75,
        maxFileSize: 5120000, // bytes (5mb)
        maxHeight: 1024,
        maxWidth: 1024,
        minHeight: 75,
        minWidth: 75,
        placeholder: "/assets/images/organisation-logo-placeholder.svg",
    },
};

export default BrandingSettings;
